import type { FC } from 'react';
import { useState } from 'react';
import { Button } from '@/shared/ui/primitives';
import styles from '@/css/SelectionBottomBar.module.css';

interface SelectionBottomBarProps {
  onStartCancel?: () => void;
  onCancel: () => void;
  onMark: () => void;
  selectedCount: number;
  isLoading?: boolean;
  recordDisabled?: boolean;
}

export const SelectionBottomBar: FC<SelectionBottomBarProps> = ({
  onStartCancel,
  onCancel,
  onMark,
  selectedCount,
  isLoading = false,
  recordDisabled = false,
}) => {
  const [isExiting, setIsExiting] = useState(false);

  const handleCancel = () => {
    if (isLoading || isExiting) return;
    onStartCancel?.();
    setIsExiting(true);
  };

  const handleAnimationEnd = () => {
    if (isExiting) {
      onCancel();
    }
  };

  return (
    <div
      onAnimationEnd={handleAnimationEnd}
      className={`${styles.selectionBottomBar} ${isExiting ? styles.exit : ''}`}
    >
      <Button
        variant="ghost"
        onClick={handleCancel}
        disabled={isLoading || isExiting}
        className={styles.halfButton}
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        onClick={onMark}
        loading={isLoading}
        disabled={recordDisabled || selectedCount === 0 || isExiting}
        className={styles.halfButton}
      >
        Record visits
      </Button>
    </div>
  );
};
